import React from "react";
import { useForm } from "react-final-form";
import { TextField } from "@syos-music/form";

import { Grid } from "@mui/material";

function Label({ locale, label }) {
  return (
    <>
      {locale === "fr" && "🇫🇷 "}
      {locale === "en" && "🇬🇧 "}
      {label}
    </>
  );
}

export default function IntlSlugField({ prefix, name, label, ...props }) {
  const form = useForm();
  const value = {
    fr: form.getFieldState(`${name}.fr`)?.value,
    en: form.getFieldState(`${name}.en`)?.value,
  };

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <TextField
          name={`${name}.en`}
          label={<Label locale="en" label={label} />}
          helperText={`/en${prefix}${value?.en}`}
          {...props}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          name={`${name}.fr`}
          label={<Label locale="fr" label={label} />}
          helperText={`/fr${prefix}${value?.fr}`}
          {...props}
        />
      </Grid>
    </Grid>
  );
}

IntlSlugField.defaultProps = {
  prefix: "/",
};
